export default __webpack_public_path__ + "images/4f3f473f7af4f446f1df27dd838c8021.svg";